﻿(function() {
    "use strict";

    angular.module("app").controller("DashboardController", DashboardController);

    DashboardController.$inject = [ "$q", "userApi"];

    function DashboardController($q, userApi) {
        $q(() => {
             userApi.getCurrentUser()
        })
    }
})();
